import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export const Close = ({ className, ...props }: IconProps) => (
  <Icon
    className={classNames('close-icon', className)}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect
      width="22"
      height="2"
      rx="1"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 0.337891 2.10547)"
      fill="currentColor"
    />
    <rect
      x="15.8945"
      y="0.337891"
      width="2"
      height="22"
      rx="1"
      transform="rotate(45 15.8945 0.337891)"
      fill="currentColor"
    />
  </Icon>
);
